var map = {
	"./de/buttons.json": 4964,
	"./de/dialogs.json": 296,
	"./de/elements.json": 6626,
	"./de/music.json": 5430,
	"./de/shortcuts.json": 2206,
	"./el/buttons.json": 166,
	"./el/dialogs.json": 8670,
	"./el/elements.json": 3752,
	"./el/music.json": 8672,
	"./el/shortcuts.json": 9124,
	"./en/buttons.json": 1084,
	"./en/dialogs.json": 3920,
	"./en/elements.json": 8938,
	"./en/help/help.json": 6266,
	"./en/music.json": 7742,
	"./en/shortcuts.json": 6294,
	"./fr/buttons.json": 6011,
	"./fr/dialogs.json": 4283,
	"./fr/elements.json": 115,
	"./fr/help/help.json": 4869,
	"./fr/music.json": 6717,
	"./fr/shortcuts.json": 8513,
	"./hr/buttons.json": 6097,
	"./hr/dialogs.json": 3589,
	"./hr/elements.json": 7901,
	"./hr/music.json": 8571,
	"./hr/shortcuts.json": 923,
	"./it/buttons.json": 3410,
	"./it/dialogs.json": 1458,
	"./it/elements.json": 4028,
	"./it/music.json": 9956,
	"./it/shortcuts.json": 2392,
	"./sl/buttons.json": 2692,
	"./sl/dialogs.json": 6664,
	"./sl/elements.json": 5538,
	"./sl/music.json": 2022,
	"./sl/shortcuts.json": 8878,
	"./zh-Hans/buttons.json": 2772,
	"./zh-Hans/dialogs.json": 1944,
	"./zh-Hans/elements.json": 9506,
	"./zh-Hans/music.json": 6726,
	"./zh-Hans/shortcuts.json": 4990
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4649;